import React from 'react'

import Header from '../../templates/Header';
import Footer from '../../templates/Footer';
import SEO from '../../templates/SEO';

import Testimonials from '../../templates/Testimonials';

import course_1 from '../../../assets/images/stocks-1.jpg';

function Future_Options() {
  return (
    <div>
        
<SEO title="The Futures & Options Page"/>

<Header/>


<div class=" aboutarea__5">
    <div class="container">
        <div class="row">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                <div class="herobannerarea__content__wraper">


                    <div class="herobannerarea__title">
                        <div class="herobannerarea__small__title">
                            <span>BASIC PROGRAMS</span>
                        </div>
                        <div class="herobannerarea__title__heading__2 herobannerarea__title__heading__3">
                            <h2>Foundation of Futures & Options</h2>
                        </div>
                    </div>


                    <div class="herobannerarea__text herobannerarea__text__2">
                        <p>This module introduces you to the world of Futures and Options, two of the most powerful financial derivatives in the market. It’s designed to give you a solid foundation in these instruments, so you can make informed decisions, manage risk, and seize market opportunities.
                            <br /> Perfect for those looking to go beyond stocks and enter the exciting world of F&O trading with confidence. </p>
                    </div>
                    {/* <div class="hreobannerarea__button__2">
                        <a class="default__button" href="#">View Courses</a>
                        <a class="default__button hreobannerarea__button__3" href="#">Explore More</a>
                    </div> */}
                </div>


                <div class="aboutarea__list__2">
                    <p> Maximize Your Market Potential by Learning: </p>
                        <ul>
                            <li>
                               ✅ &nbsp; Derivatives & Futures Contracts
                            </li>

                            <li>
                            ✅ &nbsp; Options (Call & Put)
                            </li>

                            <li>
                            ✅ &nbsp; Strike Price, Premium & Expiry
                            </li>
                            <li>
                            ✅ &nbsp; Margin, Leverage & Risk Control
                            </li>
                            <li>
                            ✅ &nbsp; Hedging & Speculation Techniques
                            </li>
                            <li>
                            ✅ &nbsp; Intrinsic Value vs. Time Value
                            </li>
                            <li>
                            ✅ &nbsp; Moneyness (ITM, ATM, OTM)
                            </li>
                            <li>
                            ✅ &nbsp; Open Interest & Volume Insights
                            </li>
                            <li>
                            ✅ &nbsp; Option Greeks (Delta, Gamma, Theta, Vega, Rho)
                            </li>
                           
                        </ul>
                    </div>
{/* <div class="hreobannerarea__button__2">
                        <a class="default__button" href="#">Buy Now</a>
                        <a class="default__button hreobannerarea__button__3" href="/contact">Contact Us</a>
                    </div> */}




            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">

                {/* <div class="herobanner__video registerarea__video">
                    <img loading="lazy" src="img/herobanner/herobanner__video.jpg" alt="Video Banner" />

                    <div class="video__pop__btn">
                        <a class="video-btn" href="https://www.youtube.com/watch?v=vHdclsdkp28"> <img loading="lazy" src="img/icon/video.png" alt=""/></a>
                    </div>
                </div> */}



<div class="gridarea__wraper">
                            <div class="gridarea__img">
                                <a href="course-details.html"><img loading="lazy"  src={course_1} alt="grid"/></a>
                                <div class="gridarea__small__button gridarea__small__button__1">
                                    <div class="grid__badge">Basics Programs</div>
                                </div>
                                <div class="gridarea__small__icon">
                                    <a href="#"><i class="icofont-heart-alt"></i></a>
                                </div>

                            </div>
                            <div class="gridarea__content">
                              
                                <div class="gridarea__heading">
                                    <h3><a href="">Foundation of Futures & Options</a></h3>
                                    <p>Derivatives simplified</p>
                                </div>
                               
                                <div class="gridarea__price">
                                ₹9,999 + GST 
                                </div>
                                <div class="hreobannerarea__button__2">
                        <a class="default__button d-block text-center"  href="#">Buy Now</a>
                        
                    </div>
                 
                            </div>
                        </div>





                

            </div>

         
        </div>
    </div>
</div>


<Testimonials/>


<Footer/>

      
    </div>
  )
}

export default Future_Options
